<script>

    import MicIcon from "./MicIcon.svelte";
    import CamIcon from "./CamIcon.svelte";
    import SpeakerIcon from "./SpeakerIcon.svelte";
    import SettingsIcon from "./SettingsIcon.svelte";
    import ChatIcon from "./ChatIcon.svelte";
    import HangupIcon from "./HangupIcon.svelte";
    import FullscreenIcon from "./FullscreenIcon.svelte";

    export let type;
    export let isMuted;
    export let handleClick;
    export let openChat;
    export let isFullscreen = false;
    let text = type === "snd/rcv monitor" ? "stream" : type;

    //let text = type === "snd/rcv monitor" ? "snd/rcv\nmonitor" : type;
    // if (type === "snd/rcv monitor"){
    //     if (Peers_Handler.self_peer.type === "en g")
    //         text = "snd/rcv\nmonitor";
    //     else
    //         text = "speaker"; 
    // }

</script>

<div class="iconWrapper" class:hangup={type === "hangup"}>

    <!-- Changes the button class based on value of those vars -- Not a great setup since those aren't necessarily mutually exclusive? -->
    <button 
        class="btn:rounded icon" 
        class:hangup={type === "hangup"} 
        class:active={openChat}
        on:click={() => handleClick(type)}
    >
        {#if type === "microphone"}
            <MicIcon isMuted={isMuted}/>
        {:else if type === "camera"}
            <CamIcon isMuted={isMuted}/>
        {:else if type === "settings"}
           <SettingsIcon/>
        {:else if type === "chat"}
           <ChatIcon openChat={openChat}/>
        {:else if type === "hangup"}
            <HangupIcon/>
        {:else if type === "snd/rcv monitor"}
            <SpeakerIcon isMuted={isMuted}/>
        {:else if type === "fullscreen"}
            <FullscreenIcon isFullscreen={isFullscreen}/>
        {/if}
    </button>

    <p class="iconLabel" class:hangup={type === "hangup"}>{text}</p>

</div>

<style lang="scss">

    @import "../styles/main.scss";

    .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        
        height: 52px;
        width: 52px;
        
        color: #be9d86;
        font-size: 22px;

        border-radius: 8px;
        border: 1px solid rgba(246, 223, 206, 0.15);
        
        background: linear-gradient(
            145deg,
            rgba(60, 65, 81, 0.25) 0%,
            rgba(40, 43, 54, 0.35) 100%
        );
        
        box-shadow: 
            -1px 1px 0px 0px rgba(250, 235, 215, 0.2),
            inset 0 1px 1px rgba(255, 255, 255, 0.05);
        
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        &:hover {
            background: linear-gradient(
                145deg,
                rgba(60, 65, 81, 0.35) 0%,
                rgba(40, 43, 54, 0.45) 100%
            );
            transform: translateY(-1px);
            box-shadow: 
                -1px 2px 3px rgba(0, 0, 0, 0.2),
                inset 0 1px 1px rgba(255, 255, 255, 0.05);
            text-shadow: 0 0 8px rgba(190, 157, 134, 0.4);
        }

        &:active {
            transform: translateY(1px);
            box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
        }

        &.hangup {
            color: rgba(220, 53, 70, 0.85);
            background: linear-gradient(
                145deg,
                rgba(90, 30, 35, 0.25) 0%,
                rgba(60, 20, 25, 0.35) 100%
            );
        }
    }

    .iconWrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
    }

    .iconLabel {
        font-size: 0.85rem;
        color: rgba(190, 157, 134, 0.7);
        font-weight: 300;
        letter-spacing: 0.5px;
        text-transform: lowercase;
        white-space: pre-line;
    }
   

</style>
